import { Request, Response } from "express"

import { getInstructions, addInstructions, patchInstructions } from "#services/recipe/instructions"

export const getRecipeInstructions = async (req: Request, res: Response) => {
	const list = await getInstructions({
		id: req.params.recipeID,
	})

	res.json(list)
}

export const addRecipeInstructions = async (req: Request, res: Response) => {
	const results = await addInstructions(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}

export const updateRecipeInstructions = async (req: Request, res: Response) => {
	const results = await patchInstructions(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}
